import React from 'react';
import './App.css';

import Appbar from './AppBar/Appbar';

import Home from "./MyPages/Main/Main";
import About from "./MyPages/AboutMe/AboutMe";
import MyWork from "./MyPages/MyWork/MyWork";
import Contact from "./MyPages/Contact/Contact";
import FooterIcon from './FooterIcons/FooterIcon';


function App() {
  return (
    <div className="App">
      <Appbar />

      <main>
        <section id="home">
          <Home />
        </section>
        <section id="about">
         <About />
        </section>
        <section id="work">
          <MyWork />
        </section>
        <section id="contact">
          <Contact />
        </section>
        <section id="footer">
          <FooterIcon />
        </section>
      </main>
    </div>
  );
}

export default App;